import { AddToCartActionOption, CartEvents } from '@wix/wixstores-client-core';
import { EcomPlatformViewerScriptContext } from '../../../viewer-script/types';
import { ILeanGQLCartModel } from '../../../services/current-cart-service/types';
import { SPECS } from '../../../constants';
import { getLeanGQLCartFromCartV1 } from '../../../services/current-cart-service/getLeanGQLCartFromCartV1';
import { getLeanGQLCartFromCart } from '../../../services/current-cart-service/getLeanGQLCartFromCart';
import type { BaseActionsParams } from '../../types';
import { BaseActions } from './baseActions';

export class TinyCartActions extends BaseActions {
  private readonly context: EcomPlatformViewerScriptContext;
  constructor({
    siteStore,
    origin,
    context,
  }: BaseActionsParams & { context: EcomPlatformViewerScriptContext }) {
    super({ siteStore, origin });
    this.context = context;
  }

  public async showTinyCart({
    addedProductId,
  }: { addedProductId?: string } = {}): Promise<void> {
    let leanGQLCartModel: ILeanGQLCartModel;
    if (
      this.siteStore.experiments.enabled(SPECS.CallCartV2FromCartComponents)
    ) {
      leanGQLCartModel = await getLeanGQLCartFromCart({
        currentCartService: this.context.currentCartService,
        wixApi: this.context.wixApi!,
        platformServices: this.context.platformServices!,
      });
    } else {
      leanGQLCartModel = await getLeanGQLCartFromCartV1(
        this.context.currentCartService,
      );
    }
    if (addedProductId) {
      this.siteStore.pubSubManager.publish(CartEvents.CHANGED, {
        ...leanGQLCartModel,
        extraParams: { origin: 'ShowTinyCart' },
        eventOptions: {
          shouldOpenCart: true,
          addToCartActionOption: AddToCartActionOption.TINY_CART,
          addedProductId,
          originatedInWorker: true,
        },
        reason: 'ShowTinyCart',
      });
    } else {
      this.siteStore.pubSubManager.publish('Tinycart.Show', null);
    }
  }

  public hideTinyCart(): void {
    this.siteStore.pubSubManager.publish('Tinycart.Hide', null);
  }
}
